module.exports = __webpack_public_path__ + "img/cd-dublu-craciun.86b2e89f.jpg";